import {IconProps} from './types';

function DuplicateIcon({fill = 'none', stroke = 'black'}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill={fill}>
            <path d="M15.6051 2.33188V1.60958C15.6051 1.14934 15.232 0.776245 14.7718 0.776245H1.66048C1.20024 0.776245 0.827148 1.14934 0.827148 1.60958V14.7208C0.827148 15.1811 1.20024 15.5542 1.66048 15.5542H2.38278" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M19.1735 18.3904C19.1735 18.8505 18.8004 19.2237 18.3402 19.2237H6.06478C5.60455 19.2237 5.23145 18.8505 5.23145 18.3904V6.11495C5.23145 5.65472 5.60455 5.28162 6.06478 5.28162H18.3402C18.8004 5.28162 19.1735 5.65472 19.1735 6.11495V18.3904Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12.2021 15.7284V8.77686" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8.72754 12.2526H15.679" stroke={stroke} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

export default DuplicateIcon;
